module.exports = __webpack_public_path__ + "img/erroricon.448d71fd.png";